export default __webpack_public_path__ + "static/media/undo.c4581a44.png";